import { render } from "./ProfileFrame.vue?vue&type=template&id=7849d1b4"
import script from "./ProfileFrame.vue?vue&type=script&lang=js"
export * from "./ProfileFrame.vue?vue&type=script&lang=js"

import "./ProfileFrame.vue?vue&type=style&index=0&id=7849d1b4&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__